// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__Gm3xO","inner":"Footer_inner__1hzex","nextIcon":"Footer_nextIcon__3zQha","innerLeft":"Footer_innerLeft__3O3uq"};